class Country {
  static china(): string {
    return '44';
  }

  static hongKong(): string {
    return '96';
  }

  static japan(): string {
    return '107';
  }

  static korea(): string {
    return '113';
  }

  static france(): string {
    return '73';
  }

  static italy(): string {
    return '105';
  }

  static unitedKingdom(): string {
    return '222';
  }

  static unitedStates(): string {
    return '223';
  }

  static canada() {
    return '38';
  }

  static australia() {
    return '13';
  }

  static regionalPopupCountries(): string[] {
    return [this.china(), this.japan(), this.hongKong(), this.korea()];
  }
}

export default Country;
